var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSandboxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.0875 1.78125L9.09375 1.77813H9.09688L6 0L2.90469 1.77813H2.90156L2.9125 1.78281L0.367188 3.25V9.75L6 13L11.6328 9.75V3.25L9.0875 1.78125ZM5.54219 11.6812L3.30625 10.3906V8.20938L1.28125 7.05937V4.32656L5.54219 6.78438V11.6812ZM1.72187 3.52344L3.82656 2.30781L5.99687 3.55312L8.17031 2.30469L10.2828 3.52344L6.00313 5.99219L1.72187 3.52344ZM10.7188 7.06719L8.70625 8.20938V10.3828L6.45781 11.6797V6.7875L10.7188 4.32969V7.06719Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSandboxIcon);
export default __webpack_public_path__ + "static/media/sandbox_icon.00b7e31a.svg";
export { ForwardRef as ReactComponent };